import { type FunctionComponent } from 'react';
import { type ProductBrandFieldsFragment } from '../../../__generated__/graphql-client-types';
import { BRANDS_LINK } from '../../../constants/links';
import { type RelatedCategory } from '../../../types/product.types';
import { StyledLink } from '../../common-components/link/styled-link.component';
import { PanelComponent } from '../../common-components/panel-component/panel-component.component';

export type RelatedCategoriesPanelProps = {
	brand: ProductBrandFieldsFragment;
	categories: RelatedCategory[];
};

export const RelatedCategoriesPanel: FunctionComponent<RelatedCategoriesPanelProps> = ({ brand, categories }) => (
	<PanelComponent headingContent={`Related ${brand.name} Categories`} className="f5">
		<ul className="list ma0 ml1 pa0">
			<li>
				<StyledLink url={BRANDS_LINK}>Browse by Brand</StyledLink>
			</li>

			{categories.map((category) => (
				<li key={category.id} className="mt1">
					<StyledLink url={category.url}>{category.name}</StyledLink>
				</li>
			))}
		</ul>
	</PanelComponent>
);
